import { Content } from '@components/PromotionWidget/PromotionWidget.styled';

export const UIConstants = {
    payAmount: 'PAYMENT STATUS',
    payDue: 'Payment Due',
    loanInProgress: 'LOAN IN PROGRESS',
    loanInProgressWidgetId: 'loanInProgressWidget',
    viewDetails: 'VIEW DETAILS',
    nextDue: 'NEXT PAYMENT DUE ON',
    makePayment: 'Make Payment',
    thanksMsg: 'Thank you for your payment.',
    minDue: 'MINIMUM DUE : ',
    timeOut: 'Your session is about to time out.',
    learnMore: 'Learn More',
    stayInSession: 'Stay in Session',
    interestRate: 'Interest Rate',
    escrowBalance: 'Escrow Balance',
    maturing: 'Maturing',
    viewAccountDetails: 'View Account Details',
    viewStatement: 'View Statement',
    quickActions: 'Quick Actions',
    taxDocuments: 'Tax Documents',
    featureProducts: 'Feature Products',
    ActiveLossMitigationForeclosureHold: 'ActiveLossMitigationForeclosureHold',
    statusLossMitigationRepaymentPlan: 'statusLossMitigationRepaymentPlan',
    notificationByStatus: [
        {
            status: 'Active Foreclosure',
            statusKey: 'activeForeclosure',
            content: 'Your account is active in foreclosure.',
            type: 'error'
        },
        {
            status: 'Foreclosed',
            statusKey: 'statusForeclosed',
            content: 'This account is no longer active.',
            type: 'error'
        },
        {
            status: 'Bankruptcy',
            statusKey: 'statusBankruptcy',
            content: 'Your account is in bankruptcy. Contact Freedom Customer Care at 855-690-5900.',
            type: 'error'
        },
        {
            status: 'Loss Mitigation',
            statusKey: 'statusLossMitigation',
            content: 'Your account is active in Loss Mitigation. Select "Pay Now" to make a one time payment.',
            type: 'error'
        },
        {
            status: 'Loss Mitigation',
            statusKey: 'ActiveLossMitigationForeclosureHold',
            content: 'You recently applied for loss mitigation assistance.',
            type: 'error'
        },
        {
            status: 'Loss Mitigation with RP',
            statusKey: 'statusLossMitigationRepaymentPlan',
            content: 'Your account is active in Loss Mitigation with a repayment plan in place.',
            type: 'error'
        },
        {
            status: 'Delinquent',
            statusKey: 'statusDelinquent',
            content: 'Your account is delinquent. Select "Pay Now" to make a one time payment.',
            type: 'error'
        },
        {
            status: 'Delinquent with RP',
            statusKey: 'statusDelinquentRP',
            content: 'Your account is Delinquent with a repayment plan in place.',
            type: 'error'
        },
        {
            status: 'Severely Delinquent',
            statusKey: 'statusSevereDel',
            content: 'Your account is delinquent. Select "Pay Now" to make a one time payment.',
            type: 'error'
        },
        {
            status: 'Severely Delinquent with RP',
            statusKey: 'statusSevereDelRP',
            content: 'Your account is Delinquent with a repayment plan in place.',
            type: 'error'
        },
        {
            status: 'Paid Off',
            statusKey: 'PaidOffStatus',
            content: 'Your account is paid in full. We thank you for being a great customer.',
            type: 'success'
        },
        {
            status: 'Inactive',
            statusKey: 'InactiveStatus',
            content: 'This account is no longer active.',
            type: 'error'
        },
        {
            status: 'Pending Service Release',
            statusKey: '',
            content: 'Your account is pending service release.',
            type: 'error'
        },
        {
            status: 'Service Released',
            statusKey: 'statusServiceReleased',
            content: 'The servicing of your mortgage loan has been transferred.',
            type: 'error'
        }
    ],

    myProfile: {
        heading: 'Manage My Online Profile',
        subHeading: 'View your personal information',
        instructions: 'Update your email address, phone number, and password.',
        manageProfile: 'MANAGE PROFILE'
    },
    icons: {
        eagleIcon:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/207cb4c3-6f01-40b3-80eb-33951e791aea/renditions/d986702e-a7f0-4053-b372-9d66bd8549c0?binary=true',
        contactIcon:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/e89f54f7-0ec6-40cf-a8e4-8fa654cd0e3f/renditions/c00116ec-6bf4-47b4-8c9f-b04c0c63619d?binary=true',
        accountIcon:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/a1919ea9-feef-4a00-bddf-4918d67a23a3/renditions/10b6c8e8-b718-4ecc-b0c5-3295dc3e2bf7?binary=true',
        footerIcon:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/13605720-a107-4259-864f-4e73b75c8367/renditions/f5c5d10d-38dc-4788-a19e-8a3a6f9fb614?binary=true',
        errorIcon:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/61932afa-314f-4f1b-ad89-d7dafbbcd95e/renditions/bf72c52f-8558-419c-a8cf-8e796f8bb441?binary=true'
    },
    errorComponent: {
        heading: "Oops! It's us, not you.",
        accountLockedHeading: 'Oops! Account locked.',
        accountLockedSubHeading:
            'You have exceeded the maximum number of failed login attempts. Your account has been locked for security reasons. Please contact the Service Desk.',

        subHeading: 'This page is currently unavailable. Try again later or if you need help now, give us a call.',
        contactUs: 'Contact us:',
        phoneNo: '855-690-5900',
        unAuthUserSubHeadingErrorMsg:
            'The Freedom Mortgage Site Admin Tool is no longer accessible from this location. Please use the new URL or the shortcut found in engage.'
    },

    userProfile: {
        id: 'user_profile_url',
        name: 'User Profile',
        url: 'accountConnectProfile'
    },
    purchase: {
        heading: 'Thinking of buying a new home?',
        subHeading: 'Get pre-qualified in minutes',
        checkList: [
            {
                id: 1,
                text: 'Apply online and get your prequalification letter in as little as 5 minutes'
            },
            {
                id: 2,
                text: 'Competitive interest rates'
            },
            {
                id: 3,
                text: 'Purchase a primary, vacation or rental home or an investment property'
            }
        ],
        imgSrc: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/a02f8549-d902-4505-8f18-fe76557ebce3/renditions/a6a8ada4-4983-4dec-b3b9-ca0d68d94636?binary=true',
        link: 'purchaseWidgetLink',
        linkText: 'GET PREQUALIFIED TODAY'
    },
    cashOut: {
        heading: 'Need cash to pay expenses?',
        subHeading: 'Tap into your home’s equity',
        checkList: [
            {
                id: 1,
                text: 'Find out how much your home is worth'
            },
            {
                id: 2,
                text: 'Calculate your potential cashout based on the difference between your home’s value and mortgage balance'
            },
            {
                id: 3,
                text: 'Consolidate debt, pay for renovations or education with the extra cash'
            }
        ],
        imgSrc: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/9c7175df-b79f-4d7f-9ede-01af5a7240de/renditions/3ef629df-3f08-413a-913a-1394c8138c87?binary=true',
        link: 'cashOutWidgetLink',
        linkText: 'GET THE DETAILS'
    },
    footerComponent: {
        addressSection1: '951 Yamato Road, Boca Raton, FL 33431 United States.',
        lenderText: 'Lender NMLS ID: 2767.',
        nmlsConsumerText: 'NMLS Consumer Access.',
        equalHousingText: 'Equal Housing Opportunity.',
        footerLinks: [
            { link: 'https://www.freedommortgage.com/disclosures', text: 'Legal Disclosures' },
            { link: 'https://www.freedommortgage.com/disclosures/privacy-policy', text: 'Privacy Notice' },
            { link: 'https://www.freedommortgage.com/disclosures/california-privacy-policy', text: 'California Privacy Notice' },
            { link: 'https://www.freedommortgage.com/disclosures/terms-and-conditions', text: 'Terms and Conditions' },
            { link: 'https://www.freedommortgage.com/disclosures/state-licensing', text: 'State Licensing' }
        ],
        copyRight: '© Freedom Mortgage Corporation.'
    },
    navigationOptions: [
        {
            id: 'logout_url',
            name: 'Log Out',
            url: 'accountConnectLogout'
        }
    ],
    promotionWidget: {
        buttonText: 'GET THE APP',
        availableOn: 'Available on',
        downloadApp: 'Download the Freedom Mortgage app on',
        googlePlay: 'Google Play',
        appStore: 'App Store',
        smartLink: 'https://smart.link/e3xkh88t7vycn',
        imgSrcGooglePlay:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/a947d515-a57d-44f2-a7f4-03e9ecf424be/renditions/3d00c8b4-7353-4c00-8fc8-6fc4a974a68d?binary=true',
        imgSrcAppStore:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/35c62886-579d-4538-aa08-254c89aeb85e/renditions/f4ed6eb9-50d9-4133-892c-08fb6951c795?binary=true'
    },
    loadingText: 'Getting your information...',
    propertyAddress: {
        address1: '69 DAWES ST',
        address2: '',
        city: 'SPRINGFIELD',
        state: 'NY',
        zip: '11420'
    },
    contactUsOption: [
        {
            id: 'contact_us',
            name: 'Contact Us',
            type: 'only_text'
        },
        {
            id: 'call_at',
            name: 'Give us a call at:',
            url: '855-690-5900',
            type: 'text_and_link'
        }
    ],
    welcomeText: 'Welcome to your Freedom Account',
    accountSelection: 'Your Account(s)',
    yourOffers: 'YOUR OFFERS',
    loanProgress: 'You have new loan in progress',
    alertIconSrc:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/d26e6158-80d9-46e0-8217-5580b97a2feb/renditions/ea3e3dea-c369-43d6-8136-0769d950476e?binary=true',
    arrowIconSrc:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/54eecfb8-fa4b-4752-8304-c363763f3e53/renditions/0c46bbda-df21-4f20-9893-d56c433a33b5?binary=true',
    ok: 'OK',
    closeIcon:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/b08f0e6d-bfc2-4e54-88c2-e833c025fdc3/renditions/dfd1efbf-ec0a-49b6-b3ab-bad49d99dbdd?binary=true',
    closeIconRed:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/d69a8b4f-5fc4-464b-ab2e-d086079da52f/renditions/0897cec5-1872-4d62-82ce-5dfcc96eeb65?binary=true',
    errorTitle: 'Error',
    errorDetails: 'Document is currently not available. Please try again later.',
    enrollNow: 'ENROLL NOW',
    confirmationTitle: 'Confirmation',
    confirmationDetails: 'PaperLess Disclaimer',
    confirmationHeading: 'FREEDOM MORTGAGE LOAN',
    checkIconGreen:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/7161b021-f3bb-45d9-b0a9-a69f5c79f61d/renditions/75101148-5a41-4297-a3ef-7877761ccef9?binary=true',
    close: 'CLOSE',
    submittedDetails: 'Your request change has been submitted. The changes will go into effect within the next 24 hours.',
    enrollErrorDetails: 'Error! Unable to enroll now. Please try again later.',
    dueDate: 'Due Date',
    amountDue: 'Amount Due',
    paymentTC: '* The amount and date are subject to change',
    paperlessSuccessMessage: 'Paperless statement enrollment indicator is updated successfully.',
    escrowScheduledText: 'Your Escrow Analysis for tax and insurance is scheduled. ',
    escrowCompletedText: 'Your Escrow Analysis for tax and insurance is complete. ',
    escrowSeeMoreText: 'Your escrow review is scheduled for ',
    escrowSeeMoreTextEffective: 'Changes to the escrow portion of your payment will be effective on ',
    escrowLearnMoreText: 'Learn more about escrow analysis here.',
    escrowLearnMoreLink: 'https://www.freedommortgage.com/learning-center/articles/escrow-analysis',
    seeMore: 'See More',
    viewResults: 'View Results',
    alertImgSrc:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/7b101923-c80f-4471-a651-acf2e18ecdaa/items/b768f08b-32b0-47b8-bb3a-96be937ea494/renditions/656422bb-0c53-4fb4-8a85-6c2642f7155d?binary=true',
    closeIconWhite:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/e9810627-8508-4c5f-b7f1-91b83e5c5489/items/52ec3509-7f16-42bc-970e-c1caec7059b5/renditions/15212a24-86db-4a00-b5a6-5927dfbb8c1d?binary=true',
    accountDetails: {
        titlePastDue: 'Payment Past Due',
        titleCurrentAcc: 'Upcoming Payment',
        payDueDate: 'Payment Due Date',
        setAutoPay: 'Set Up Autopay',
        payHistory: 'View Payment History',
        viewStmt: 'View Current Statement'
    },
    LOADER_GIF:
        'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/1b993aba-f65a-45ff-9d1b-acccb18c0cd9/renditions/8173d561-2af4-4991-93d7-4196c9103aab?binary=true',
    ThankyouTextSuccess: 'Thank you for your request to get cash from your home’s equity. We will reach out to you soon.',
    messageCentreInfoText1: 'You can now send and receive messages here, in our new Message Center. You can find older messages in ',
    messageCentreInfoText2: 'your archives.'
};

const onSuccess = {
    mainHeading: 'Thank you for submitting your request,',
    subHeading: 'A Loan Advisor will call you soon so we can complete your request.'
};

const onError = {
    mainHeading: 'Something went wrong on our end,',
    subHeading: 'Don’t worry, we will be looking into this error to fix it in the meantime.',
    additionalInfo: {
        text: 'Call us now to speak with a licensed Loan Advisor who can quickly process your request.',
        number: '(833) 500-1460'
    }
};

export const UnTargetedOffer = ['ANC_CO', 'ANC_Prequal', 'ANC_Homes'];

export const ThankYou = { onSuccess, onError };
export const allowedVWOActionsMapping: Record<string, string> = {
    OfferLinkClicked: 'offerLinkClicked',
    'Offer Displayed': 'offerDisplayed',
    OfferDisplayed: 'popDisplayed',
    OfferButtonCTA1Clicked: 'offerButtonCTA1Clicked',
    OfferButtonCTA2Clicked: 'offerButtonCTA2Clicked',
    OfferDialerClicked: 'offerDialerClicked',
    'OfferDNIS/TFNClicked': 'offerDNIS/TFNClicked',
    CashOutLeadSubmitSuccess: 'cashOutLeadSubmitSuccess',
    CashOutLeadUpdateSuccess: 'cashOutLeadUpdateSuccess',
    PurchaseLeadSubmitSuccess: 'purchaseLeadSubmitSuccess',
    PurchaseLeadUpdateSuccess: 'purchaseLeadUpdateSuccess',
    StreamLineLeadSubmitSuccess: 'streamLineLeadSubmitSuccess',
    StreamLineLeadUpdateSuccess: 'streamLineLeadUpdateSuccess',
    RateTermLeadSubmitSuccess: 'rateTermLeadSubmitSuccess',
    RateTermLeadUpdateSuccess: 'rateTermLeadUpdateSuccess',
    SubmittingCashOutInitialLead: 'leadFormDisplayed',
    SubmittingPurchaseInitialLead: 'leadFormDisplayed',
    SubmittingStreamLineInitialLead: 'leadFormDisplayed',
    SubmittingRateTermInitialLead: 'leadFormDisplayed'
};
